import React from "react";
import { useTranslation } from "react-i18next";
import { FaRegCalendarCheck, FaArrowRight } from "react-icons/fa";
import { businessLogic } from "../../lib/constants";
import { trackConversion } from "../../lib/analytics";

/**
 * Banner de la auditoría de IA gratuita para agencias. Va como primer bloque de
 * la home, justo debajo de la cabecera.
 *
 * Mismo lenguaje visual que el MeetupCommunityBanner del blog (card con
 * gradiente sutil de marca, borde lila, kicker en mayúsculas, título en negrita,
 * descripción muted y CTA morado), pero en horizontal porque aquí ocupa el ancho
 * completo en vez de una columna de sidebar.
 */
const AiAuditBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="ai-audit-banner__area">
      <div className="container">
        <a
          className="ai-audit-banner"
          href={businessLogic.aiAuditLink}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackConversion("AI Audit Banner")}
        >
          <div className="ai-audit-banner__content">
            <span className="ai-audit-banner__kicker">
              <FaRegCalendarCheck aria-hidden="true" />
              {t("ai_audit_kicker")}
            </span>
            <h2 className="ai-audit-banner__title">{t("ai_audit_title")}</h2>
            <p className="ai-audit-banner__text">{t("ai_audit_text")}</p>
          </div>

          <span className="ai-audit-banner__cta">
            {t("ai_audit_cta")}
            <FaArrowRight aria-hidden="true" />
          </span>
        </a>
      </div>
    </section>
  );
};

export default AiAuditBanner;
